import { useState } from 'react';
import TextField from '@mui/material/TextField';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import PersonAdd from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import Stack from '@mui/material/Stack';
import { v4 as uuidv4 } from 'uuid';

function PlayerManagement({ onAddPlayer, onResetAll }) {

    const [playerName, setPlayerName] = useState("");

    const handleAddPlayer = (e) => {
        e.preventDefault();
        if (!playerName.trim()) return;
        onAddPlayer({
            id: uuidv4(),
            name: playerName.trim(),
            sessions: [],
            passes: 0,
            shots: 0,
            goals: 0
        });
        setPlayerName("");
    };

    return (
        <Stack direction="row" spacing={1}>
            <TextField
                id="outlined-basic"
                label="Pelaajan nimi"
                variant="outlined"
                value={playerName}
                onChange={e => setPlayerName(e.target.value)}
            />
            <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <IconButton onClick={handleAddPlayer} disabled={!playerName.trim()}><PersonAdd /></IconButton>
                <IconButton color="error" onClick={onResetAll}><DeleteIcon /></IconButton>
            </ButtonGroup>
        </Stack>
    )
}

export default PlayerManagement;